<template>
  <div>
    <nav class="navbar navbar-expand-sm daqs-header">
      <div class="container">
        <span class="navbar-brand">
          <img
            src="@/assets/image001.png"
            width="50"
            height="50"
            alt="NRBSS Logo"
          >
          &nbsp;
          2018 RECREATIONAL BOATING SURVEY RESULTS VIEWER
        </span>
      </div>
    </nav>
    <nav class="navbar navbar-expand-sm daqs-nav navbar-dark">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <div class="container">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link
                :to="'/'"
                class="nav-link"
              >
                HOME
              </router-link>
            </li>
            <li
              class="nav-item"
              v-for="page in pages"
              :key="page"
            >
              <router-link
                :to="page"
                class="nav-link"
              >
                {{ page | titleFormat }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'DaqsNav',
  filters: {
    titleFormat: function (value) {
      if (value.includes('_')) {
        let split = value.split('_')
        return split[0] + ' (' + split[1] + ')'
      }
      return value
    }
  }
}
</script>
